import angular from 'angular';
import sectionsLibraryService from '../../../SectionsLibraryService';
import toolbarService from '../../../../Toolbar/ToolbarService';
import Width from "../../../../ConfigParameters/ConfigParameters/Width";
import Placeholder from "../../../../ConfigParameters/ConfigParameters/Placeholder";
import CustomClassName from "../../../../ConfigParameters/ConfigParameters/CustomClassName";

const MODULE_NAME = 'formCaptcha';

const creatorFormInputCaptcha = {
    bindings: {
        elementModel: '=',
        parentModel: '<'
    },
    controller: function (ToolbarService) {
        let defaultConfig = ToolbarService.getSectionDefaultSchema(MODULE_NAME);

        this.$onInit = () => {
            this.elementModel = angular.copy(angular.extend(defaultConfig, this.elementModel));
        };
    },
    template: require('./captchaInput.html')
};

export default angular.module('cms.creator.form.input.captcha', [sectionsLibraryService, toolbarService])
    .run(function (SectionsLibraryService, ToolbarService, gettext) {

        SectionsLibraryService.registerSection({
            icon: 'expand',
            type: MODULE_NAME,
            label: gettext('Captcha'),
            group: 'form',
            hidden: true,
            options: {
                disableRemove: true,
                disableCopy: true,
            },
            groups: {
                mainConfig: {
                    label: gettext('Main config'),
                    isOpen: true,
                    type: 'mainConfig'
                },
                advanced: {
                    label: gettext('Advanced'),
                    isOpen: false,
                    type: 'advanced'
                }
            }
        });

        let placeholder = new Placeholder();
        placeholder.setInputType('hidden');
        ToolbarService.registerSectionSchema(MODULE_NAME, {
            ...(placeholder),
            ...(new Width()),
            ...(new CustomClassName())
        })
    })
    .component('cmsCreatorFormInputCaptcha', creatorFormInputCaptcha).name;



// WEBPACK FOOTER //
// ./src/cmsCore/Creator/SectionsLibrary/Sections/Form/CaptchaInput/captchaInput.js